<div *ngIf="reportType == 'VeryBriefly-Officer'" class="report-wrapper">
    <div class="report-container" id="print-section">

        <!-- Report Header Section -->
        <div class="report-header">
            <div class="header-row">
                <div class="company-name">Vivek Saptahik</div>
                <div class="report-title">Advt. Payment Receipt Ledger</div>
                <div class="report-type">Very Briefly</div>
                <div class="report-date">{{ currentDate | date: 'dd-MM-yyyy' }}</div>
            </div>
            <div class="sub-header-row">
                <div class="report-category"></div>
                <div class="date-range">From {{ startDate | date: 'dd-MM-yyyy' }} To {{ endDate | date: 'dd-MM-yyyy' }}
                </div>
            </div>
        </div>

        <!-- Main Report Table -->
        <div class="table-container">
            <table class="report-table">
                <thead>
                    <tr class="table-header">
                        <th class="col-rep-name">Representative Name</th>
                        <th class="col-amount">Received Amount</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let data of advtFormBeans; let i = index">

                        <!-- Office Representative Header -->
                        <tr class="office-rep-header">
                            <td colspan="2" class="office-rep-title">
                                <span class="office-rep-label">Office Representative:</span>
                                <span class="office-rep-name">{{ data.office_rep }}</span>
                            </td>
                        </tr>

                        <!-- Representative Data Rows -->
                        <tr *ngFor="let data1 of data.rep_data; let j = index" class="rep-data-row">
                            <td class="rep-name">{{ data1.rep_name }}</td>
                            <td class="amount" style="text-align: right;">{{ (data1.rcv_amt * 1).toFixed(2) }}</td>
                        </tr>

                        <!-- Subtotal Row -->
                        <tr class="subtotal-row">
                            <td class="subtotal-label">{{ data.office_rep }}</td>
                            <td class="subtotal-amount" style="text-align: right;">{{ (data.total * 1).toFixed(2) }}
                            </td>
                        </tr>

                    </ng-container>

                    <!-- Grand Total Footer -->
                    <tr class="grand-total-row">
                        <td class="grand-total-label">GRAND TOTAL:</td>
                        <td class="grand-total-amount" style="text-align: right;">{{ (advtVBTotal * 1).toFixed(2) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>

    <!-- Action Buttons -->
    <div class="action-buttons noPrint">
        <button class="btn btn-export noPrint" (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button
            color="primary">
            <mat-icon>download</mat-icon>
            Export to Excel
        </button>

        <button class="btn btn-print noPrint" id="print-button" mat-raised-button color="primary"
            printSectionId="print-section" [useExistingCss]="true" ngxPrint style="display: none;">
            Print
        </button>

        <button class="btn btn-print noPrint" mat-raised-button color="primary" printSectionId="print-section"
            [useExistingCss]="true" ngxPrint>
            Print
        </button>

        <button class="btn btn-close noPrint" mat-button mat-dialog-close>
            <mat-icon>close</mat-icon>
            Close
        </button>
    </div>
</div>